"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ramda_1 = require("ramda");
// returns true if neither a nor b return true
const neither = (a, b) => ramda_1.complement(ramda_1.either(a, b));
exports.default = neither;
